import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { components } from '@/components/ui/Form/SelectBase';
import { LockIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
/**
 * コンサルサーチ：ソート用のセレクトボックスに表示するSingleValue用コンポーネント
 * @param props
 * @constructor
 */
export const CSearchSelectSortSingleValue = (props) => {
    var _a, _b;
    return (_jsx(components.SingleValue, Object.assign({}, props, { children: _jsxs("div", Object.assign({ className: 'w-full flex justify-between' }, { children: [_jsx("span", { children: ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.label) || '' }), ((_b = props === null || props === void 0 ? void 0 : props.selectProps) === null || _b === void 0 ? void 0 : _b.isDisabled) && (_jsx(LockIcon, { color: 'inactive', size: 'md' }))] })) })));
};
